import {UseFormReset} from 'react-hook-form'
import {SliceStatus} from './Redux.types'
import {AUTH_PROVIDER} from './Login.types'

export enum ValidUserTypesOld {
  Administrator = 'Administrator',
  User = 'Read-Only',
}

export enum UserImportStatus {
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
}

export const RoleNames = {
  Administrator: 'Administrator',
  'Read-Only': 'Read Only',
  Analyst: 'SOC Analyst',
}

export const ValidUserTypes = {
  Administrator: 'Administrator',
  User: 'Read-Only',
  Analyst: 'Analyst',
}

export const allValidRoles = [
  ValidUserTypes.Administrator,
  ValidUserTypes.User,
  ValidUserTypes.Analyst,
]

export enum IMPORT_LIST_TYPE {
  groups = 'groups',
  users = 'users',
}

export interface ListInvitedAdminsTypes {
  role: string
  name: string
  createdOn: string
  emailId: string
  updatedOn: string
  invitationStatus: string
}

export interface BlockPagesResponse {
  Item: ListBlockPages
}

export interface DefaultBlockPage {
  label: string
  url: string
  defaultLanguage?: string
  pageId: string
  pageTitle?: string
  bodyMessage?: string
  type?: string
}

export interface CustomBlockPage {
  pageId?: string
  url?: string
  type: string
  label: string
  html?: string
}

export interface ListBlockPages {
  pages: {
    default: DefaultBlockPage[]
    custom: CustomBlockPage[]
    dope_default: CustomBlockPage[]
  }
}

export interface SettingThrowError {
  value: string
  throwError?: boolean
}

export interface EndpointConfigState {
  data: EndpointsConfigTypes
  snapshot: EndpointsConfigTypes
  status: SliceStatus
  isFormValid: boolean
  showConfigView: boolean
}

export type EndpointsConfigTypes = {
  allowedDomains: string[]
  antiTamperPassword: string
  authProvider: string
  endpointVersion: string
  failClosed: boolean
  installedEndpoints: number
  requireDelegatedAuth: boolean
}

export interface UpdateEndpointsConfigAction {
  allowedDomains?: string[]
  antiTamperPassword?: string
  failClosed?: boolean
  requireDelegatedAuth?: boolean
}

export type UsersGroupsTypes = {
  Users: {emailId: string; name: string; type: string}[]
  Groups: {emailId: string; name: string; membersCount: string}[]
}

export type AddCustomPages = {
  label: string
  type: string
  html: string
}

export type UpdateCustomPage = {
  html?: string
  label?: string
  type: string
  pageId: string
}

export type UpdateCustomBlockPages = {
  addCustomPages?: AddCustomPages[]
  updateCustomPages?: UpdateCustomPage[]
  deleteCustomPages?: string[]
}

export type UsersAndGroupsLastEvaluatedKeyTypes = {
  emailId?: string
  tenantId?: string
}

export enum BlockPageFallbackTypes {
  defaultBlock = 'defaultBlock',
  defaultWarning = 'defaultWarning',
  defaultSecurity = 'defaultSecurity',
  defaultError = 'defaultError',
  defaultCloudApplication = 'defaultCloudApplication',
}

export interface DefaultBlockPagePayload {
  defaultPages: DefaultBlockPageList[]
}

export interface DefaultBlockPageList {
  html: string
  pageId: string
}

export interface GetUserGroupDetailsResponse {
  message: string
  response: GetUserGroupDetailsResponseNode
}

export interface GetUserGroupDetailsResponseNode {
  [x: string]: UserGroupDetailsState
}

export interface UserGroupDetailsState {
  show?: boolean
  name: string
  emailId: string
  groupIds: string[]
  groupNames: string[]
  status?: SliceStatus
  error: string
}

export interface ImportLinkState {
  url: string
  message: string
  notifier_type: string
  sns_topic: string
  status: SliceStatus
}

export interface SearchUsersGroupsItem {
  label: string
  options: UsersGroupsOption[]
}

export interface UsersGroupsOption {
  emailId: string
  name: string
  membersCount?: string
  type: string
}

export interface GetImportStatusResponse {
  authProvider: AUTH_PROVIDER
  importStatus: UserImportStatus
  lastUpdated?: string
  reauthRequired?: boolean
}

export interface BlockPageList {
  label: string
  value: string
  type: string
}
export interface ShowUserGroupDetailPayload {
  show: boolean
  emailId?: string
  name?: string
}

export interface Roles {
  label: string
  role: string
}

export interface AdminFormPayload {
  emails: string
  role: string
}

export interface GeneralFormParams {
  emailId: string[]
  role: string
  reset: UseFormReset<AdminFormPayload>
}

export interface InviteAdminsParams {
  emails: string
  role: string
  reset: UseFormReset<AdminFormPayload>
}

export interface UpdateInvitedAdminsPayload {
  emailId: string
  role: string
}

export interface DeleteAdminPayload {
  emailId: string
  onSuccess: () => void
  userName?: string
}

export enum APIStatus {
  Success = 'success',
  Error = 'error',
  Loading = 'loading',
}

export interface APITableProps {
  data: APIData
  setEditMode: (value: boolean) => void
}

export interface RHSPanelProps {
  data: APIData
  isEditMode: boolean
  setEditMode: (value: boolean) => void
}

export interface Creds {
  name: string
  clientId: string
  createdBy: string
  createdOn: string
  clientSecret?: string
}

export interface APIData {
  creds: Creds[]
}

export interface APIKeysSuccessResponse {
  data: APIData
}

interface ErrorDetail {
  details?: string
  message?: string
}

export interface APIKeysErrorResponse {
  error: ErrorDetail[]
}

export interface APIKeysCreateSuccessData {
  cred: Creds
}

export interface APIKeysCreateSuccessResponse {
  data: APIKeysCreateSuccessData
}

export type APIKeysCreateResponse =
  | APIKeysCreateSuccessResponse
  | APIKeysErrorResponse

export interface APIQueryData {
  data: APIData
  status: number
  statusText: string
  headers: Record<string, unknown>
  config: Record<string, unknown>
}

export interface TokenRowProps {
  cred: Creds
  isLastCred: boolean
  data: APIData
  index: number
}

export interface TokenName {
  name: string
}

export interface GenerateTokenPayload {
  cred: TokenName
}
